import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TgrServiceService } from '../../../service/tgr-service.service';
import { Tgr } from '../../../interface/tgr';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tgr-form',
  templateUrl: './tgr-form.component.html',
  styleUrls: ['./tgr-form.component.scss'],
})
export class TgrFormComponent {
  public tgrInterface: Tgr;
  public booleanFlag: boolean;
  public dateDay: Date = new Date();
  public rut: number;
  public update: boolean;

  
  constructor(
    private route: ActivatedRoute,
    private tgrService: TgrServiceService,
    private router: Router,
    public dialogRef: MatDialogRef<TgrFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number
  ) {
    this.route.queryParams.subscribe((params) => {
      this.rut = params['client'] || data;
      console.log('Cliente: ' + this.rut);
    });
  }

  formRegisterTgr = new FormGroup({
    amountt: new FormControl('', [Validators.required]),
    check: new FormControl(),
    fechaDeuda: new FormControl(),
  });

  get f() {
    return this.formRegisterTgr.controls;
  }

  async submit() {
    var { amountt, check, fechaDeuda } = this.formRegisterTgr.value;

    if (check == null) {
      check = false;
    }

    this.booleanFlag = true;
    this.tgrService.newTgr(this.rut).subscribe({
      next: (next) => {
        this.booleanFlag = false;
        Swal.fire({
          title: 'Registro Realizado',
          icon: 'success',
        }).then((result) => {
          if (result.isConfirmed) {
            this.update = true;
            this.dialogRef.close(this.update);
          }
        });
      },
      error: (error) => {
        Swal.fire({
          title: 'Error',
          text: error.error,
          icon: 'error',
          timerProgressBar: true,
        });
        this.booleanFlag = false;
      },
    });
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }

  getTgr(companyId: number) {
    this.tgrService.getTgr(companyId).subscribe((e) => (this.tgrInterface = e));
  }
}
